<template>
  <v-card>
    <v-toolbar flat color="white" density="compact">
      <v-tabs v-model="tab" slider-color="success">
        <v-tab value="general_info">{{ $store.getters.translate("general_info").toUpperCase() }}</v-tab>
        <v-tab value="additional_information">{{ $store.getters.translate("additional_information").toUpperCase() }}</v-tab>
        <v-tab value="financial_information" v-if="page.name === 'candidates'">{{ $store.getters.translate("financial_information").toUpperCase() }}</v-tab>
        <v-tab value="orders" v-if="page.name === 'candidates'">{{ $store.getters.translate("orders").toUpperCase() }}</v-tab>
      </v-tabs>
      <v-spacer/>
      <div class="chip-container">
        <base-action-button v-if="page.name !== 'profile'" @action="exportPerson('pdf')">
          <template #prepend><PhFilePdf style="vertical-align: middle; margin-right: 5px;" size="20" /></template>
          {{ $store.getters.translate("export_to_pdf") }}
        </base-action-button>
        <base-action-button v-if="page.name !== 'profile'" @action="exportPerson('excel')">
          <template #prepend><PhFileXls style="vertical-align: middle; margin-right: 5px;" size="20" /></template>
          {{ $store.getters.translate("export_to_excel") }}
        </base-action-button>
        <base-action-button v-if="page.name !== 'profile' && canDelete" :delete="true" @action="archive">
          <template #prepend><PhArchive style="vertical-align: middle; margin-right: 5px;" size="20" /></template>
          {{ $store.getters.translate("delete") }}
        </base-action-button>
        <base-action-button v-if="canEdit" @action="save">
          <template #prepend><PhFloppyDisk style="vertical-align: middle; margin-right: 5px;" size="20" /></template>
          {{ $store.getters.translate("save") }}
        </base-action-button>
      </div>
    </v-toolbar>
    <v-row>
      <v-col cols="3">
        <base-profile-photo :isDisabled="!canEdit" :person="record.person" @refresh="save"/>
        <v-row v-if="record.person && $store.getters.getUser.is_admin" :class="!record.person.user ? 'mb-5' : ''">
          <v-col class="pa-0 text-center">
            <base-create-user v-if="!record.person.user" :person="record.person" @refresh="$emit('refresh')"/>
            <base-notification v-else @refresh="$emit('refresh')" :user_id="record.person.user.id"/>
          </v-col>
        </v-row>
        <v-row v-if="canLoginAsPerson">
          <v-col class="pa-0 mt-3 text-center">
            <base-action-button @action="loginAsPerson">
              <template #prepend><PhUserCircle style="vertical-align: middle; margin-right: 5px;" size="20" /></template>
              {{ $store.getters.translate("login_as_person") }}
            </base-action-button>
          </v-col>
        </v-row>
        <v-row v-if="record.person.user">
          <v-col class="pa-0 mt-3 text-center">
            <base-action-button @action="resetPassword">
              <template #prepend><PhArrowsCounterClockwise style="vertical-align: middle; margin-right: 5px;" size="20" /></template>
              {{ $store.getters.translate("reset_password") }}
            </base-action-button>
          </v-col>
        </v-row>
        <v-row v-if="record.person.user" :class="page.name === 'profile' ? '' : 'mb-5'">
          <v-col class="pa-0 mt-3 text-center">
            <base-action-button :delete="true" @action="deleteUser">
              <template #prepend><PhUserMinus style="vertical-align: middle; margin-right: 5px;" size="20" /></template>
              {{ $store.getters.translate("delete_account") }}
            </base-action-button>
          </v-col>
        </v-row>
<!--    <v-row v-if="page.name === 'candidates' && record.person.user && (!record.contacts || record.contacts.length === 0)" :class="page.name === 'profile' ? '' : 'mb-5'">
          <v-col class="pa-0 mt-3 text-center">
            <base-create-contact :person="record.person" @refresh="$emit('refresh')"/>
          </v-col>
        </v-row>-->
        <v-row v-if="page.name === 'profile'">
          <v-col class="pa-0 mt-3 text-center">
            <div style="display: inline-block;">
              <v-checkbox style="float: left;" color="success" density="compact" hide-details v-model="record.notify_is_on"/>
              <span class="pl-3 sm-normal" style="display: block; height: 40px; align-content: center;">{{ $store.getters.translate('turn_on_notifications') }}</span>
            </div>
          </v-col>
        </v-row>
        <v-row v-if="page.name === 'profile'" class="mb-5">
          <v-col class="pa-0 mt-3 text-center">
            <v-btn-toggle v-model="record.language" density="compact" base-color="white" color="primary" rounded="xl" border>
              <v-btn value="nl">
                {{ $store.getters.translate('nl') }}
              </v-btn>
              <v-btn value="en">
                {{ $store.getters.translate('en') }}
              </v-btn>
            </v-btn-toggle>
          </v-col>
        </v-row>
      </v-col>
      <v-col>
        <v-window v-model="tab">
          <!--CANDIDATE ID, NAME AND USUAL FIELDS-->
          <v-window-item value="general_info">
            <v-card class="ma-5 pa-5" rounded="xl" border="sm" variant="outlined">
              <v-text-field
                  v-if="page.name === 'candidates'"
                  density="default"
                  variant="plain"
                  color="primary"
                  class="reg-normal"
                  hide-details
                  readonly
                  persistent-placeholder
                  v-model="candidateID">
                <template #label>
                  <span class="sm-bold text-primary">{{ $store.getters.translate('candidate_id') }}</span>
                </template>
              </v-text-field>
              <v-text-field
                  density="default"
                  class="reg-normal text-primary mt-3"
                  base-color="border-tertiary"
                  bg-color="secondary"
                  color="primary"
                  :disabled="!canEdit"
                  v-model="record.person.first_name"
                  hide-details
                  flat
                  clearable>
                <template #label>
                  <span class="sm-normal text-subtle">{{ $store.getters.translate('first_name') }}<strong>*</strong></span>
                </template>
              </v-text-field>
              <v-text-field
                  density="default"
                  class="reg-normal text-primary mt-3"
                  base-color="border-tertiary"
                  bg-color="secondary"
                  color="primary"
                  :disabled="!canEdit"
                  v-model="record.person.insertion"
                  hide-details
                  flat
                  clearable>
                <template #label>
                  <span class="sm-normal text-subtle">{{ $store.getters.translate('insertion') }}</span>
                </template>
              </v-text-field>
              <v-text-field
                  density="default"
                  class="reg-normal text-primary mt-3"
                  base-color="border-tertiary"
                  bg-color="secondary"
                  color="primary"
                  :disabled="!canEdit"
                  v-model="record.person.last_name"
                  hide-details
                  flat
                  clearable>
                <template #label>
                  <span class="sm-normal text-subtle">{{ $store.getters.translate('last_name') }}<strong>*</strong></span>
                </template>
              </v-text-field>
              <v-text-field
                  density="default"
                  class="reg-normal text-primary mt-3"
                  base-color="border-tertiary"
                  bg-color="secondary"
                  color="primary"
                  :disabled="!canEdit"
                  v-model="record.person.initials"
                  hide-details
                  flat
                  clearable>
                <template #label>
                  <span class="sm-normal text-subtle">{{ $store.getters.translate('initials') }}</span>
                </template>
              </v-text-field>
              <template v-for="field in usual_fields">
                <template v-if="field.name === 'is_dyslexic' || field.name === 'is_dyscalc' || field.name === 'preferred_certificate_language' || field.name === 'jobtitle' || field.name === 'type'">
                  <base-field
                      v-if="page.name !== 'profile'"
                      :isDisabled="!canEdit"
                      :key="field.name"
                      :modelValue="record[field.name]"
                      :field="field"
                      @change="usualFieldDataChanged"/>
                </template>
                <!--EXCLUDE NAME FIELD BECAUSE IT`S ALREADY SHOWN BEFORE AS FIRST AND LAST NAME -->
                <template v-else-if="field.name !== 'name'">
                  <base-field
                      :isDisabled="!canEdit"
                      :key="field.name"
                      :modelValue="record.person[field.name]"
                      :field="field"
                      @change="usualFieldDataChanged"/>
                </template>
              </template>
              <base-field
                  v-for="field in custom_fields"
                  :key="field.name"
                  :modelValue="record.custom_fields[field.name]"
                  :field="field"
                  @change="customFieldDataChanged"/>
            </v-card>
          </v-window-item>
          <!--USUAL EMAILS AND ADDRESSES AND LOGS (CANDIDATES PAGE ONLY)-->
          <v-window-item value="additional_information">
            <v-card class="ma-5 pa-5" rounded="xl" border="sm" variant="outlined">
              <v-text-field
                  v-if="page.name !== 'profile' && record.person.user"
                  density="default"
                  class="reg-normal text-primary"
                  base-color="border-tertiary"
                  bg-color="secondary"
                  color="primary"
                  :disabled="!canEdit"
                  v-model="record.person.user.email"
                  hide-details
                  flat
                  clearable>
                <template #label>
                  <span class="sm-normal text-subtle">{{ $store.getters.translate('user_email') }}</span>
                </template>
              </v-text-field>
              <base-email-addresses :isDisabled="!canEdit" v-model="record.person.emailaddresses" email_type="personal" label="emailaddress" @update="emailsChanged"/>
              <base-addresses :isDisabled="!canEdit" v-model="record.person.addresses" address_type="visiting" label="contact_address" @update="addressesChanged"/>
              <template v-if="page.name === 'candidates'">
                <v-text-field
                    v-if="record.stipel_candidate && record.stipel_candidate.s_candidate_id"
                    density="default"
                    variant="plain"
                    color="primary"
                    class="reg-normal mt-3"
                    hide-details
                    readonly
                    persistent-placeholder
                    v-model="record.stipel_candidate.s_candidate_id">
                  <template #label>
                    <span class="sm-bold text-primary">{{ $store.getters.translate('stipel') }}</span>
                  </template>
                </v-text-field>
                <base-log-field model_type="Candidate" :model_id="record.id" button_location="bottom" :expand="true"/>
                <base-log-field v-if="record.dossiers && record.dossiers.length > 0" model_type="Dossier" :model_id="record.dossiers[record.dossiers.length-1].id" button_location="bottom" :expand="true"/>
              </template>
            </v-card>
          </v-window-item>
          <!--BILLING EMAILS AND ADDRESSES (CANDIDATES PAGE)-->
          <v-window-item value="financial_information" v-if="page.name === 'candidates'">
            <v-card class="ma-5 pa-5" rounded="xl" border="sm" variant="outlined">
              <v-text-field
                  density="default"
                  class="reg-normal text-primary"
                  base-color="border-tertiary"
                  bg-color="secondary"
                  color="primary"
                  :disabled="!canEdit"
                  v-model="record.person.financial_name"
                  hide-details
                  flat
                  clearable>
                <template #label>
                  <span class="sm-normal text-subtle">{{ $store.getters.translate('financial_name') }}</span>
                </template>
              </v-text-field>
              <base-email-addresses :isDisabled="!canEdit" v-model="record.person.emailaddresses" email_type="billing" label="billing_email" @update="emailsChanged"/>
              <div class="mt-3" style="display: flex;">
                <v-checkbox style="float: left;" color="success" density="compact" hide-details v-model="hide_billing_address"/>
                <span class="pl-3 sm-normal" style="display: block; height: 40px; align-content: center;">{{ $store.getters.translate('billing_address_the_same') }}</span>
              </div>
              <base-addresses v-if="!hide_billing_address" :isDisabled="!canEdit" v-model="record.person.addresses" address_type="billing" label="billing_address" @update="addressesChanged"/>
            </v-card>
          </v-window-item>
          <!--CANDIDATE ORDERS ONLY ON CANDIDATES PAGE-->
<!--          <v-window-item value="orders" v-if="page.name === 'candidates'">
            <v-card class="ma-5 pa-5" rounded="xl" border="sm" variant="outlined">
              <v-table>
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th>{{ $store.getters.translate('id') }}</th>
                      <th>{{ $store.getters.translate('exam_name') }}</th>
                      <th style="width: 140px;text-align: center;padding: 0;">{{ $store.getters.translate('order_id') }}</th>
                      <th style="width: 100px;text-align: center;padding: 0;">{{ $store.getters.translate('is_payed') }}</th>
                      <th style="width: 140px;text-align: center;padding: 0;">{{ $store.getters.translate('invoice_id') }}</th>
                      <th style="width: 100px;text-align: center;padding: 0;">{{ $store.getters.translate('is_billed') }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(exam, index) in record.exams" :key="index">
                      <td>
                        <a @click="$router.push('/exams/' + exam.id)">{{ exam.id }}</a>
                      </td>
                      <td>
                        <a @click="$router.push('/exams/' + exam.id)">{{ exam.name }}</a>
                      </td>
                      <td style="text-align: center;">
                        <v-text-field
                            density="compact"
                            class="centered-input reg-normal text-primary"
                            base-color="border-tertiary"
                            bg-color="secondary"
                            color="primary"
                            v-model="exam.pivot.order_id"
                            hide-details
                            flat
                            @change="updateOrder(exam.pivot)"/>
                      </td>
                      <td style="text-align: center;">
                        <v-checkbox v-model="exam.pivot.is_payed" style="display: -webkit-inline-box;" color="success" density="compact" hide-details @update:model-value="updateOrder(exam.pivot)"/>
                      </td>
                      <td style="text-align: center;">
                        <v-text-field
                            density="compact"
                            class="centered-input reg-normal text-primary"
                            base-color="border-tertiary"
                            bg-color="secondary"
                            color="primary"
                            v-model="exam.pivot.invoice_id"
                            hide-details
                            flat
                            @change="updateOrder(exam.pivot)"/>
                      </td>
                      <td style="text-align: center;">
                        <v-checkbox v-model="exam.pivot.is_billed" style="display: -webkit-inline-box;" color="success" density="compact" hide-details @update:model-value="updateOrder(exam.pivot)"/>
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-table>
            </v-card>
          </v-window-item>-->
          <!--CANDIDATE SNELSTART ORDERS ONLY ON CANDIDATES PAGE-->
          <v-window-item value="orders" v-if="page.name === 'candidates'">
            <v-card class="ma-5 pa-5" rounded="xl" border="sm" variant="outlined">
              <v-table>
                <template v-slot:default>
                  <thead>
                  <tr>
                    <th>{{ $store.getters.translate('id') }}</th>
                    <th>{{ $store.getters.translate('exam_name') }}</th>
                    <th style="width: 140px;text-align: center;padding: 0;">{{ $store.getters.translate('type') }}</th>
                    <th style="width: 140px;text-align: center;padding: 0;">{{ $store.getters.translate('order_id') }}</th>
                    <th style="width: 100px;text-align: center;padding: 0;">{{ $store.getters.translate('billed') }}</th>
                    <th style="width: 140px;text-align: center;padding: 0;">{{ $store.getters.translate('invoice_id') }}</th>
                    <th style="width: 100px;text-align: center;padding: 0;">{{ $store.getters.translate('paid') }}</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="(order, index) in record.orders" :key="index">
                    <td>
                      <a @click="$router.push('/exams/' + order.id)">{{ order.id }}</a>
                    </td>
                    <td>
                      <a @click="$router.push('/exams/' + order.id)">{{ order.name }}</a>
                    </td>
                    <td style="text-align: center;">
                      {{ orderType(order.type) }}
                    </td>
                    <td style="text-align: center;">
                      <v-text-field
                          disabled
                          density="compact"
                          class="centered-input reg-normal text-primary"
                          base-color="border-tertiary"
                          bg-color="secondary"
                          color="primary"
                          v-model="order.order_number"
                          hide-details
                          flat
                      />
                    </td>
                    <td style="text-align: center;">
                      <v-checkbox
                          disabled
                          v-model="order.billed"
                          style="display: -webkit-inline-box;"
                          color="success"
                          density="compact"
                          hide-details
                      />
                    </td>
                    <td style="text-align: center;">
                      <v-text-field
                          disabled
                          density="compact"
                          class="centered-input reg-normal text-primary"
                          base-color="border-tertiary"
                          bg-color="secondary"
                          color="primary"
                          v-model="order.invoice_number"
                          hide-details
                          flat
                      />
                    </td>
                    <td style="text-align: center;">
                      <v-checkbox
                          disabled
                          v-model="order.paid"
                          style="display: -webkit-inline-box;"
                          color="success"
                          density="compact"
                          hide-details
                    />
                    </td>
                  </tr>
                  </tbody>
                </template>
              </v-table>
            </v-card>
          </v-window-item>
        </v-window>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import { useAbility } from '@casl/vue';
import helpFunctions from "../../plugins/helpFunctions";
import plannerFunctions from "../../plugins/plannerFunctions";
import BaseCreateUser from "./BaseCreateUser";
import BaseNotification from "./BaseNotification";
import BaseProfilePhoto from "./BaseProfilePhoto";
import BaseAddresses from "../../components/commonComponents/BaseAddresses";
import BaseEmailAddresses from "./BaseEmailAddresses";
import BaseLogField from "./BaseLogField";
import BaseActionButton from "./BaseActionButton";
import {PhArchive, PhArrowsCounterClockwise, PhFloppyDisk, PhUserMinus, PhFilePdf, PhFileXls, PhUserCircle} from "@phosphor-icons/vue";
import axios from "../../plugins/axios";
import router from "../../router";

export default {
  props: ["page", "record"],
  components: {
    BaseCreateUser,
    BaseNotification,
    BaseProfilePhoto,
    BaseAddresses,
    BaseEmailAddresses,
    BaseLogField,
    BaseActionButton,
    PhUserMinus, PhArrowsCounterClockwise, PhFloppyDisk, PhArchive, PhFilePdf, PhFileXls, PhUserCircle
  },
  setup() {
    const { can } = new useAbility();
    return { can }
  },
  data() {
    return {
      tab: "general_info",
      usual_fields: [],
      custom_fields: [],
      hide_billing_address: true,
      exams_for_export: [],
      record_results: [],
      dossier_counter: 0,
    };
  },
  mounted() {
    this.getFields();
  },
  methods: {
    async save() {
      let error = false;
      if (this.record.person.first_name === '' || this.record.person.last_name === '') {
        this.$toast.error(this.$store.getters.translate("required_field") + ": " + this.$store.getters.translate('name'));
        error = true;
      }
      this.usual_fields.forEach((field) => {
        if (field.mandatory && field.field_type !== 'boolean' && field.name !== 'is_dyslexic' && field.name !== 'is_dyscalc' && field.name !== 'preferred_certificate_language' && field.name !== 'jobtitle' && field.name !== 'type' && field.name !== 'name') {
          if(!this.record.person[field.name] || this.record.person[field.name] === '') {
            this.$toast.error(this.$store.getters.translate("required_field") + ": " + this.$store.getters.translate(field.name));
            error = true;
          }
        }
      });
      if(!error) {
        if(this.record.person.phonenumber && this.record.person.phonenumber.charAt(0) !== '+') {
          this.$toast.error(this.$store.getters.translate("international_number_error"));
        }
        else if(this.record.person.mobilenumber && this.record.person.mobilenumber.charAt(0) !== '+') {
          this.$toast.error(this.$store.getters.translate("international_number_error"));
        }
        else if(this.record.person.billingnumber && this.record.person.billingnumber.charAt(0) !== '+') {
          this.$toast.error(this.$store.getters.translate("international_number_error"));
        }
        else if(await helpFunctions.saveModel(this.$toast, this.page.name, this.record)) {
          this.$emit('refresh');
        }
      }
    },
    async updateOrder(pivot) {
      await helpFunctions.postCustomRoute(this.$toast, "update-exam-order", pivot, true, true);
    },
    exportPerson(export_type) {
      if (this.page.name === 'candidates' && this.record.dossiers.length > 0) {
        this.dossier_counter = 0;
        this.exams_for_export = [];
        this.record_results = [];
        this.loadDossiers(export_type, this.record.dossiers[0].id);
      }
      else {
        let html = plannerFunctions.exportPerson(export_type, this.page.model, this.record, this.usual_fields);
        if (export_type === 'excel') {
          this.exportTableToExcel(html, this.record.name);
        } else {
          this.exportTableToPdf(html, this.record.name);
        }
      }
    },
    async loadDossiers(export_type, dossier_id) {
      let dossier = await helpFunctions.loadModel(this.$toast, "dossiers", dossier_id);
      if (dossier.exams && dossier.exams.length > 0) {
        for (let i = 0; i < dossier.exams.length; i++) {
          let temp = {
            id: dossier.id,
            scheme: dossier.scheme,
            scheme_id: dossier.scheme_id,
            candidate_id: dossier.candidate_id,
            results: []
          };
          for (let x = 0; x < dossier.results.length; x++) {
            if (dossier.results[x].session != null && dossier.results[x].session.exam_id === dossier.exams[i].id) {
              temp.results.push(dossier.results[x]);
            }
          }
          this.exams_for_export.push(dossier.exams[i]);
          this.record_results.push(temp);
        }
      }
      this.dossier_counter++;
      if (this.dossier_counter < this.record.dossiers.length) {
        await this.loadDossiers(export_type, this.record.dossiers[this.dossier_counter].id);
      }
      else {
        this.record.exams_for_export = this.exams_for_export;
        this.record.record_results = this.record_results;
        let html = plannerFunctions.exportPerson(export_type, this.page.model, this.record, this.usual_fields);
        if (export_type === 'excel') {
          this.exportTableToExcel(html, this.record.name);
        }
        else {
          this.exportTableToPdf(html, this.record.name);
        }
      }
    },
    exportTableToPdf(html, file_name) {
      this.$http
          .post(this.$store.getters.appUrl + "v2/pdf/generate-pdf", {html: html, file_name: file_name}, {responseType: "blob"})
          .then((response) => {
            const blob = new Blob([response.data], {type: "application/pdf"});
            const link = document.createElement("a");
            link.href = URL.createObjectURL(blob);
            link.download = file_name + ".pdf";
            link.click();
            URL.revokeObjectURL(link.href);
          });
    },
    exportTableToExcel(html, file_name) {
      const link = document.createElement("a");
      link.href = 'data: application/vnd.ms-excel, ' + html.replace(/ /g, '%20');
      link.download = file_name + ".xls";
      link.click();
    },
    async archive() {
      this.$confirm(this.$store.getters.translate("confirm")).then(async (res) => {
        if (res) {
          await helpFunctions.deleteModel(this.$toast, this.page.name, this.record.id);
          await this.$router.push("/" + this.page.name);
        }
      });
    },
    async loginAsPerson() {
      const data = await helpFunctions.postCustomRoute(this.$toast, "impersonation/login", { user_id: this.record.person.user.id }, false, true);
      if(data.status !== 'success') { return; }
      this.$store.commit('impersonation_login', { token: data.token, user: data.user });
      this.$store.commit('auth_success', data.token);
      this.$store.commit('user', data.user);
      router.push('/portal');
    },
    async resetPassword() {
      await helpFunctions.postCustomRoute(this.$toast, "resetpassword", { email: this.record.person.user.email }, true, true);
      this.$emit('refresh');
    },
    async deleteUser() {
      this.record.person.delete_user = true;
      await helpFunctions.patchCustomRoute(this.$toast, "people/" + this.record.person.id, this.record.person, true);
      this.$emit('refresh');
    },
    usualFieldDataChanged(data) {
      if(data[0] === 'is_dyslexic' || data[0] === 'is_dyscalc' || data[0] === 'preferred_certificate_language' || data[0] === 'jobtitle' || data[0] === 'type') {
        this.record[data[0]] = data[1];
      }
      else {
        this.record.person[data[0]] = data[1];
      }
    },
    customFieldDataChanged(data) {
      this.record.custom_fields[data[0]] = data[1];
    },
    emailsChanged(updated_emails) {
      this.record.person.emailaddresses = updated_emails;
      this.save();
    },
    addressesChanged(updated_addresses) {
      this.record.person.addresses = updated_addresses;
    },
    async getFields() {
      const response = await helpFunctions.getFields(this.page.model, 'show_on_update');
      this.usual_fields = response.usual_fields;
      this.custom_fields = response.custom_fields;
    },
    refreshAddresses() {
      if(this.record && this.record.person && this.page.name === 'candidates') {
        this.record.person.addresses.forEach((address) => {
          if (address.primary) {
            this.hide_billing_address = true;
          }
        });
      }
    },
    orderType(type) {
      switch (type) {
        case 'training_course':
          return this.$store.getters.translate('course');
        case 'exam':
          return this.$store.getters.translate('exam');
        case 'session':
          return this.$store.getters.translate('session');
        default:
          return this.$store.getters.translate('unknown');
      }
    },
  },
  computed: {
    candidateID() {
      if(parseInt(this.record.id) < 10) {
        return "00000" + this.record.id;
      }
      else if(parseInt(this.record.id) < 100) {
        return "0000" + this.record.id;
      }
      else if(parseInt(this.record.id) < 1000) {
        return "000" + this.record.id;
      }
      else if(parseInt(this.record.id) < 10000) {
        return "00" + this.record.id;
      }
      else if(parseInt(this.record.id) < 100000) {
        return "0" + this.record.id;
      }
      else {
        return this.record.id;
      }
    },
    canEdit() {
      if (this.page.name === 'profile') {
        return true;
      }
      else {
        return this.can("edit", this.$createEntity(this.page.model.toLowerCase(), {id: 0}));
      }
    },
    canDelete() {
      return this.can("delete", this.$createEntity(this.page.model.toLowerCase(), { id: 0 }));
    },
    canLoginAsPerson() {
      return this.record.person.user && this.record.person.user?.type !== 'admin' && this.record.person.user?.type !== 'employee';
    },
  },
  watch: {
    record: {
      handler() {
        if(this.page.name === 'candidates') {
          this.refreshAddresses();
        }
      },
    },
    hide_billing_address: {
      async handler() {
        if (this.hide_billing_address) {
          for (let i = 0; i < this.record.person.addresses.length; i++) {
            if (this.record.person.addresses[i].type === 'billing') {
              await helpFunctions.deleteModel(this.$toast, 'addresses', this.record.person.addresses[i].id);
              this.record.person.addresses = this.record.person.addresses.filter((address) => address.id !== this.record.person.addresses[i].id);
            }
            else if (this.record.person.addresses[i].type === 'visiting' && !this.record.person.addresses[i].primary) {
              this.record.person.addresses[i].primary = 1;
              await helpFunctions.saveModel(this.$toast, 'addresses', this.record.person.addresses[i]);
            }
          }
        } else {
          for (let i = 0; i < this.record.person.addresses.length; i++) {
            if (this.record.person.addresses[i].type === 'visiting' && this.record.person.addresses[i].primary) {
              this.record.person.addresses[i].primary = 0;
              await helpFunctions.saveModelSilently('addresses', this.record.person.addresses[i]);
            }
          }
        }
      },
    },
  },
};
</script>

<style scoped>
.chip-container {
  display: flex;
  gap: 8px;
  margin-right: 16px;
}
.centered-input :deep(input) {
  text-align: center;
}
.centered-input {
  position: relative;
}
</style>